import { Link } from "react-router-dom";

const PrivacyLink = ({ testid = "privacy-policy-link" }) => (
  <Link
    to="/privacy-policy"
    data-testid={testid}
    className="font-bold text-[#0B192C] underline decoration-[#10B981] decoration-2 underline-offset-2 hover:text-[#10B981] transition-colors"
  >
    privacy policy
  </Link>
);

export default PrivacyLink;
